import { render, staticRenderFns } from "./ClientLayout.vue?vue&type=template&id=0c9718ce&"
import script from "./ClientLayout.vue?vue&type=script&lang=js&"
export * from "./ClientLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClientLayout.vue?vue&type=style&index=0&module=true&lang=scss&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./ClientLayout.vue?vue&type=style&index=0&module=true&lang=scss&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./ClientLayout.vue?vue&type=style&index=0&module=true&lang=scss&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js").rerender("0c9718ce")
            }
          }
        })

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9718ce')) {
      api.createRecord('0c9718ce', component.options)
    } else {
      api.reload('0c9718ce', component.options)
    }
    module.hot.accept("./ClientLayout.vue?vue&type=template&id=0c9718ce&", function () {
      api.rerender('0c9718ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ClientLayout.vue"
export default component.exports